export enum SenderEmailStatusEnum {
  Verified = 'dashboard.settings.mailing.sender_email.status_confirmed',
  Pending = 'dashboard.settings.mailing.sender_email.status_pending',
}
